// Format a 10-digit phone number as (XXX) XXX-XXXX
export function formatPhoneNumber(phone: string | null | undefined): string {
  if (!phone) return "";
  // Strip non-digits
  const digits = phone.replace(/\D/g, "");
  // Handle 11-digit (1+10) — strip leading 1
  const clean = digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
  if (clean.length === 10) {
    return `(${clean.slice(0, 3)}) ${clean.slice(3, 6)}-${clean.slice(6)}`;
  }
  return phone; // Return as-is if not 10 digits
}
